import { createStore } from '@stencil/store';

import { AppRouter } from '@entities/AppRouter';
import { InformationalServiceBehavior } from '@entities/Behavior';
import { Configuration } from '@entities/Configuration';
import { FloatingButtonState } from '@entities/FloatingButtonState';
import { ServiceType } from '@entities/ServiceType';
import { TransactionalServiceType } from '@entities/TransactionalServiceType';
import { TSVisibilityType } from '@entities/TSVisibilityType';

interface State {
  configuration: Configuration;
  floatingButtonState: FloatingButtonState;
  floatingButtonStateTimeout: boolean;
  isTransactionalServiceActive: boolean;
  latestRating: number;
  reportSuiteId: string;
  route: AppRouter;
  serviceType: ServiceType;
  isFeedbackSubmitted: boolean;
  submittedSentimentsId: string;
  transactionalServiceType: TransactionalServiceType | null;
  tsAbQuestionTesting: boolean;
}

const initialState: Partial<State> = {
  configuration: {
    appearance: 0,
    behavior: InformationalServiceBehavior.OverAndOverAgain,
    tsVisibilityType: TSVisibilityType.Hidden,
    defaultState: AppRouter.DisplayNoneRoute,
    design: 0,
    position: 0,
    questionConfigId: 1,
    questions: [],
    targetedDisplays: ['desktop', 'mobile', 'tablet'],
    thankYouMessageBad: 'Tell us more.',
    thankYouMessageGood: 'Tell us more.',
    themeColor: '#222222',
    ratingScaleDesign: 0,
    widgetLabel: 'Help us improve',
    ctsgSurveyConfig: { isEnabled: false, surveyIds: [] },
  },
  floatingButtonState: FloatingButtonState.Initial,
  floatingButtonStateTimeout: true,
  route: AppRouter.DisplayNoneRoute,
  transactionalServiceType: null,
  tsAbQuestionTesting: false,
};

const store = createStore(initialState);

export default store;
